import { TextField, MenuItem } from '@mui/material';

export interface Item {
  value: any;
  label: string;
  // Desabilita a opção individualmente, mantendo-a visível. Opcional: quem não
  // informa continua com todas habilitadas, como sempre foi.
  disabled?: boolean;
}

interface Props {
  label: string;
  className?: string;
  items?: Item[];
  name: string;
  handleChange?: (e: any) => void;
  value: string;
  error: any;
  helperText: any;
  handleBlur?: any;
  disabled?: boolean;
  size?: 'small' | 'medium';
}

export const InputSelect = ({
  label,
  className,
  items,
  name,
  value,
  error,
  helperText,
  handleChange,
  handleBlur = null,
  disabled = false,
  size = 'medium',
}: Props) => {
  return (
    <TextField
      size={size}
      fullWidth
      label={label ?? ''}
      select
      value={value ?? ''}
      name={name}
      onChange={handleChange}
      onBlur={handleBlur}
      error={error}
      helperText={helperText}
      className={className}
      disabled={disabled}
    >
      {items?.map((item, index) => (
        <MenuItem key={index} value={item.value} disabled={item.disabled}>
          {item.label}
        </MenuItem>
      ))}
    </TextField>
  );
};
